<style scoped>
/*顶部提示*/
#layout-top-tip {
  text-align: center;
  padding: 10px 20px;
  width: 100%;
  font-size: 12px;
  color: #e0eaff;
  background: #24427d;
  z-index: 999;
}
#layout-top-tip a {
  color: #fcff10;
}
</style>

<template>
  <div v-if="isTopTipShow" id="layout-top-tip">
    <span>您当前网站即将在2021-05-08到期，请及时续费！</span>
    <a href="">立即续费</a>
  </div>
</template>

<script>
export default {
  name: "topTip",
  data() {
    return {
      isTopTipShow: false
    };
  }
};
</script>
